import resolve from "resolve/async";
import { promisify } from "util";
const resolvePromisify = promisify(resolve);

const onError = (error) => {
  if (error && (error.code === "ENOENT" || error.code === "ENOTDIR")) {
    return false;
  }
  return error;
};

const realPathCb = (fs) => (file, cb) => {
  fs.realpath(file)
    .then((p) => cb(undefined, p))
    .catch((err) => {
      if (err.code !== "ENOENT") {
        cb(err);
      } else {
        cb(null, file);
      }
    });
};

const isFile = (fs) => (file, cb) => {
  fs.stat(file)
    .then((stats) => cb(undefined, stats.isFile()))
    .catch((err) => cb(null, onError(err)));
};

const isDir = (fs) => (file, cb) => {
  fs.stat(file)
    .then((stats) => cb(undefined, stats.isDirectory()))
    .catch((err) => cb(null, onError(err)));
};

const readFileCb = (fs) => (file, cb) => {
  fs.readFile(file, "utf8")
    .then((data) => cb(undefined, data))
    .catch((err) => cb(err));
};

export const createResolveFsOptions = (fs) => ({
  readFile: readFileCb(fs),
  isFile: isFile(fs),
  isDirectory: isDir(fs),
  realpath: realPathCb(fs),
});

export const createResolve =
  (fs) =>
  async (target, options = {}) => {
    const resolveOptions = {
      ...createResolveFsOptions(fs),
      includeCoreModules: false,
      preserveSymlinks: false,
      ...options,
    };
    return await resolvePromisify(target, resolveOptions);
  };
